var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 4C14.9998 3.44772 14.5521 3 13.9998 3C13.4475 3 12.9998 3.44772 12.9998 4V15.9103L8.62711 12.3879C8.19702 12.0414 7.56749 12.1092 7.22103 12.5393C6.87457 12.9694 6.94236 13.599 7.37246 13.9454L13.3725 18.7788C13.7387 19.0737 14.2609 19.0737 14.6271 18.7788L20.6271 13.9454C21.0572 13.599 21.125 12.9694 20.7785 12.5393C20.4321 12.1092 19.8026 12.0414 19.3725 12.3879L14.9998 15.9103V4ZM5.99989 20C5.99989 19.4477 5.55218 19 4.99989 19C4.44761 19 3.99989 19.4477 3.99989 20V21C3.99989 23.2091 5.79075 25 7.99989 25H19.9999C22.209 25 23.9999 23.2091 23.9999 21V20C23.9999 19.4477 23.5522 19 22.9999 19C22.4476 19 21.9999 19.4477 21.9999 20V21C21.9999 22.1046 21.1045 23 19.9999 23H7.99989C6.89532 23 5.99989 22.1046 5.99989 21V20Z",
    fill: "#151C22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9d1d812d.svg";
export { ForwardRef as ReactComponent };